module.exports = __webpack_public_path__ + "static/Styczeń_kwiecień_2022-664dab8a5c51b1623c0e2477c4cd25ac.pdf";